(function () {
  // Guard against double init (modal+script are rendered once, but be safe if
  // the snippet is ever included twice on a page).
  if (window.__pickupFlowInit) return;
  window.__pickupFlowInit = true;

  // querySelector by attribute — safe with defer (currentScript is null with defer)
  const script = document.querySelector('script[data-pickup-endpoint]');
  const endpoint = script && script.dataset.pickupEndpoint;

  // Localized strings passed from Liquid (| t) via data-attributes; RO fallback.
  const ds = (script && script.dataset) || {};
  const messages = {
    error: ds.msgError || 'A aparut o eroare. Incercati din nou.',
    successTitle: ds.msgSuccessTitle || 'Comanda plasata',
    successBody: ds.msgSuccessBody || 'Comanda __ORDER__ a fost inregistrata.',
    close: ds.msgClose || 'Inchide',
    sending: ds.msgSending || 'Se trimite...',
    submit: ds.msgSubmit || 'Confirma comanda',
    phoneInvalid: ds.msgPhoneInvalid || 'Numar de telefon invalid.',
    emailInvalid: ds.msgEmailInvalid || 'Adresa de email invalida.',
    nameRequired: ds.msgNameRequired || 'Introduceti numele si prenumele.',
    emailSuggest: ds.msgEmailSuggest || 'Verificati adresa. Ati vrut sa scrieti __EMAIL__?',
  };

  // Normalize to E.164 (Moldova +373) and validate, mirroring the server.
  function normalizePhone(raw) {
    let p = String(raw || '').replace(/[\s()\-.]/g, '');
    if (p.indexOf('00') === 0) p = '+' + p.slice(2);
    else if (p.indexOf('0') === 0) p = '+373' + p.slice(1);
    else if (p.indexOf('+') !== 0) p = '+373' + p;
    return p.replace(/^\+3730+/, '+373');
  }
  // Leading digits 2/3/6/7 are the only assigned MD ranges; the server runs the
  // full libphonenumber check that Shopify applies.
  function validPhone(raw) {
    return /^\+373[2367]\d{7}$/.test(normalizePhone(raw));
  }

  const TLD_TYPOS = ['con', 'cmo', 'ocm', 'vom', 'xom', 'comm', 'cpm', 'rux', 'mdd'];
  const KNOWN_DOMAINS = [
    'gmail.com', 'yahoo.com', 'hotmail.com', 'outlook.com', 'icloud.com', 'live.com',
    'mail.ru', 'yandex.ru', 'inbox.ru', 'list.ru', 'bk.ru', 'rambler.ru', 'mail.md',
  ];

  function validEmail(raw) {
    const email = String(raw || '').trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s.]{2,}$/.test(email)) return false;
    return TLD_TYPOS.indexOf(email.slice(email.lastIndexOf('.') + 1).toLowerCase()) === -1;
  }

  function editDistance(a, b) {
    let prev = [];
    for (let j = 0; j <= b.length; j++) prev[j] = j;
    for (let i = 1; i <= a.length; i++) {
      const cur = [i];
      for (let j = 1; j <= b.length; j++) {
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
      }
      prev = cur;
    }
    return prev[b.length];
  }

  // "ana@gmail.con" -> "ana@gmail.com"; null when the domain looks intentional.
  function suggestEmail(raw) {
    const email = String(raw || '').trim();
    const at = email.lastIndexOf('@');
    if (at < 1) return null;
    const domain = email.slice(at + 1).toLowerCase();
    if (KNOWN_DOMAINS.indexOf(domain) !== -1) return null;
    let best = null;
    let bestDist = 3;
    KNOWN_DOMAINS.forEach(function (d) {
      const dist = editDistance(domain, d);
      if (dist < bestDist) { best = d; bestDist = dist; }
    });
    return best ? email.slice(0, at + 1) + best : null;
  }

  function fieldErrorEl(form, field) {
    return form.querySelector('[data-field-error="' + field + '"]');
  }

  function setFieldError(form, field, message) {
    const input = form.elements[field];
    const el = fieldErrorEl(form, field);
    if (!input || !el) return;
    input.setAttribute('aria-invalid', 'true');
    el.textContent = message;
    el.hidden = false;
  }

  function setEmailSuggestion(form, suggestion) {
    const el = fieldErrorEl(form, 'email');
    const parts = messages.emailSuggest.split('__EMAIL__');
    form.elements.email.setAttribute('aria-invalid', 'true');
    el.textContent = '';
    el.appendChild(document.createTextNode(parts[0] || ''));
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pickup-field__suggest';
    btn.setAttribute('data-email-suggest', suggestion);
    btn.textContent = suggestion;
    el.appendChild(btn);
    el.appendChild(document.createTextNode(parts[1] || ''));
    el.hidden = false;
  }

  function clearFieldError(form, field) {
    const input = form.elements[field];
    const el = fieldErrorEl(form, field);
    if (input) input.removeAttribute('aria-invalid');
    if (el) { el.hidden = true; el.textContent = ''; }
  }

  function clearAllErrors(form) {
    ['name', 'phone', 'email'].forEach(function (f) { clearFieldError(form, f); });
    const errorEl = form.querySelector('[data-pickup-error]');
    if (errorEl) errorEl.hidden = true;
  }

  // A typo suggestion on a syntactically valid address blocks the first submit
  // only; submitting the same address again sends it as typed.
  let acceptedEmail = null;
  function validateForm(form) {
    const invalid = [];
    if (!form.elements.name.value.trim()) {
      setFieldError(form, 'name', messages.nameRequired);
      invalid.push('name');
    }
    if (!validPhone(form.elements.phone.value)) {
      setFieldError(form, 'phone', messages.phoneInvalid);
      invalid.push('phone');
    }
    const email = form.elements.email.value.trim();
    const fix = suggestEmail(email);
    if (!validEmail(email)) {
      if (fix && validEmail(fix)) setEmailSuggestion(form, fix);
      else setFieldError(form, 'email', messages.emailInvalid);
      invalid.push('email');
    } else if (fix && email !== acceptedEmail) {
      acceptedEmail = email;
      setEmailSuggestion(form, fix);
      invalid.push('email');
    }
    return invalid;
  }

  const FIELD_MESSAGES = { name: 'nameRequired', phone: 'phoneInvalid', email: 'emailInvalid' };

  // items[].discounts lists every allocation on the line, order-level ones
  // included, titled with the code for code discounts. Codes go to the server
  // as real codes (so their usage limit counts); only the automatic remainder is
  // mirrored as a per-line percentage.
  function splitCartDiscounts(cart) {
    const applicable = (cart.discount_codes || [])
      .filter(function (d) { return d.applicable; })
      .map(function (d) { return String(d.code).toUpperCase(); });
    function isCode(title) { return applicable.indexOf(String(title).toUpperCase()) !== -1; }

    const usedCodes = {};
    const items = cart.items.map(function (i) {
      let automatic = 0;
      let automaticTitle = '';
      (i.discounts || []).forEach(function (d) {
        if (!(d.amount > 0)) return;
        if (isCode(d.title)) { usedCodes[String(d.title).toUpperCase()] = d.title; return; }
        automatic += d.amount;
        if (!automaticTitle) automaticTitle = d.title || '';
      });
      let discountPct = 0;
      if (i.original_line_price > 0 && automatic > 0) {
        discountPct = Math.min(100, (automatic / i.original_line_price) * 100);
      }
      return { id: i.variant_id, quantity: i.quantity, discountPct: discountPct, discountTitle: automaticTitle };
    });

    return {
      items: items,
      codes: Object.keys(usedCodes).map(function (k) { return usedCodes[k]; }),
    };
  }

  const CHECK_SVG =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M5 13l4 4L19 7" fill="none" stroke="currentColor" stroke-width="2.2" ' +
    'stroke-linecap="round" stroke-linejoin="round"/></svg>';

  let placed = false;       // an order was placed → closing reloads
  let submitting = false;   // request in flight → ignore close requests
  let lastFocused = null;   // element to restore focus to on close
  let pickupMode = 'delivery'; // tracked from any toggle (drawer or cart page)

  function modalEl() { return document.querySelector('[data-pickup-modal]'); }

  // Move the modal to <body> so position:fixed centers on the viewport,
  // escaping any transformed cart-drawer ancestor.
  function openModal() {
    const m = modalEl();
    if (!m) return;
    if (m.parentElement !== document.body) document.body.appendChild(m);
    lastFocused = document.activeElement;
    m.hidden = false;
    document.body.classList.add('pickup-lock');
    const first = m.querySelector('input, button');
    if (first) first.focus();
  }
  function closeModal() {
    if (submitting) return;
    if (placed) { window.location.reload(); return; }
    const m = modalEl();
    if (m) m.hidden = true;
    document.body.classList.remove('pickup-lock');
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  // Track the delivery/pickup choice from any toggle (drawer or cart page).
  // Each toggle uses its own radio-group name (pickup-mode-<id>), so they stay
  // visually independent; we only care about the last choice the user made.
  document.addEventListener('change', function (e) {
    if (e.target.matches('input[name^="pickup-mode"]')) pickupMode = e.target.value;
  });

  // Checkout button (drawer or cart page): intercept when pickup is selected
  document.addEventListener('click', function (e) {
    if (!e.target.closest('button[name="checkout"]')) return;
    if (pickupMode === 'pickup') {
      e.preventDefault();
      openModal();
    }
  });

  // Close via cancel/×, close button, or click on the dark overlay
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-pickup-cancel]') || e.target.closest('[data-pickup-close]')) {
      closeModal();
      return;
    }
    if (e.target.matches('[data-pickup-modal]')) closeModal();
  });

  // Keyboard: Escape closes, Tab is trapped inside the open modal
  document.addEventListener('keydown', function (e) {
    const m = modalEl();
    if (!m || m.hidden) return;
    if (e.key === 'Escape') { closeModal(); return; }
    if (e.key !== 'Tab') return;
    const focusables = Array.prototype.filter.call(
      m.querySelectorAll('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])'),
      function (el) { return !el.disabled && el.offsetParent !== null; }
    );
    if (!focusables.length) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  document.addEventListener('input', function (e) {
    const form = e.target.closest && e.target.closest('[data-pickup-form]');
    if (form && e.target.name) clearFieldError(form, e.target.name);
  });

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-email-suggest]');
    if (!btn) return;
    const form = btn.closest('[data-pickup-form]');
    form.elements.email.value = btn.getAttribute('data-email-suggest');
    clearFieldError(form, 'email');
    form.elements.email.focus();
  });

  // Form submit
  document.addEventListener('submit', async function (e) {
    if (!e.target.matches('[data-pickup-form]')) return;
    e.preventDefault();
    const form = e.target;
    const errorEl = form.querySelector('[data-pickup-error]');
    const submitBtn = form.querySelector('[data-pickup-submit]');
    const labelEl = submitBtn.querySelector('.pickup-btn__label');
    const modal = modalEl();

    function setBusy(busy) {
      submitting = busy;
      submitBtn.disabled = busy;
      submitBtn.setAttribute('aria-busy', busy ? 'true' : 'false');
      if (labelEl) labelEl.textContent = busy ? messages.sending : messages.submit;
    }

    clearAllErrors(form);
    const invalid = validateForm(form);
    if (invalid.length) {
      form.elements[invalid[0]].focus();
      return;
    }

    setBusy(true);

    try {
      const cart = await fetch('/cart.js').then(function (r) { return r.json(); });
      const discountParts = splitCartDiscounts(cart);
      const payload = {
        name: form.elements.name.value.trim(),
        phone: form.elements.phone.value.trim(),
        email: form.elements.email.value.trim(),
        acceptsMarketing: !!(form.marketing && form.marketing.checked),
        items: discountParts.items,
        discountCodes: discountParts.codes,
      };
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (!res.ok) {
        setBusy(false);
        const fields = Object.keys(FIELD_MESSAGES).filter(function (f) { return data.fields && data.fields[f]; });
        if (fields.length) {
          fields.forEach(function (f) { setFieldError(form, f, messages[FIELD_MESSAGES[f]]); });
          form.elements[fields[0]].focus();
          return;
        }
        errorEl.textContent = data.error || (data.errors && data.errors.join('. ')) || messages.error;
        errorEl.hidden = false;
        return;
      }
      await fetch('/cart/clear.js', { method: 'POST' });
      if (discountParts.codes.length) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: '' }),
        });
      }
      submitting = false;
      placed = true;
      renderSuccess(modal, (data.order && data.order.name) || '');
    } catch (err) {
      errorEl.textContent = messages.error;
      errorEl.hidden = false;
      setBusy(false);
    }
  });

  // Build the success view. Static markup via innerHTML is our own; the
  // server-supplied order name is set with textContent (XSS-safe).
  function renderSuccess(modal, orderName) {
    const box = modal.querySelector('.pickup-modal__box');
    const parts = messages.successBody.split('__ORDER__');
    box.innerHTML =
      '<span class="pickup-modal__accent" aria-hidden="true"></span>' +
      '<div class="pickup-success">' +
        '<span class="pickup-success__check">' + CHECK_SVG + '</span>' +
        '<h3 class="pickup-modal__title"></h3>' +
        '<p class="pickup-success__body"></p>' +
        '<button type="button" class="pickup-btn pickup-btn--primary" data-pickup-close></button>' +
      '</div>';
    box.querySelector('.pickup-modal__title').textContent = messages.successTitle;

    const body = box.querySelector('.pickup-success__body');
    body.appendChild(document.createTextNode(parts[0] || ''));
    const order = document.createElement('span');
    order.className = 'pickup-success__order';
    order.textContent = orderName;
    body.appendChild(order);
    body.appendChild(document.createTextNode(parts[1] || ''));

    box.querySelector('[data-pickup-close]').textContent = messages.close;
    box.querySelector('[data-pickup-close]').focus();
  }
})();
